module.exports = __webpack_public_path__ + "img/google-pay.fab5f0d.svg";